import { FC } from "react"

const ArIcon: FC = () => {
    return (
        <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_902_2231)">
                <path d="M21.4414 0.794128H26.2061V5.55883" stroke="currentColor" strokeWidth="0.794118" />
                <path d="M5.55963 0.794128H0.794922V5.55883" stroke="currentColor" strokeWidth="0.794118" />
                <path d="M26.2061 21.4412V26.2059H21.4414" stroke="currentColor" strokeWidth="0.794118" />
                <path d="M0.794922 21.4412V26.2059H5.55963" stroke="currentColor" strokeWidth="0.794118" />
                <path d="M10.6415 14.6118H8.1003L9.37089 11.2765L10.6415 14.6118ZM12.0709 18.2647H13.8179L10.4827 9.37061H8.41795L4.92383 18.2647H6.67089L7.465 16.2H11.2768L12.0709 18.2647ZM16.2003 13.3412V10.9588H18.1062C19.0591 10.9588 19.6944 11.2765 19.6944 12.2294C19.6944 13.0235 19.2179 13.5 18.1062 13.5H16.2003V13.3412ZM14.4532 18.2647H16.2003V14.9294H18.7415C19.3768 14.9294 19.5356 15.0883 19.5356 15.7235V18.2647H21.2827V15.2471C21.2827 14.453 20.8062 13.9765 19.8532 13.9765C20.8062 13.6588 21.4415 12.8647 21.4415 11.753C21.4415 10.3235 20.1709 9.37061 18.7415 9.37061H14.4532V18.2647Z" fill="currentColor" />
            </g>
            <defs>
                <clipPath id="clip0_902_2231">
                    <rect width="27" height="27" fill="currentColor" />
                </clipPath>
            </defs>
        </svg>

    )
}

export default ArIcon